import type { UserType } from "@xmiles/holopix-ai";
import { meetsMinTier } from "@/utils/memberTier";

/**
 * 将 Pinia highestPackage 映射为 GenerationTaskSimulator 的 userTier。
 * 旗舰版（ultra）排队初始值与专业版（svip）一致，对齐 usetaskQueue2 的 hasMembershipAtLeast('svip') 策略。
 */
export function resolveGenerationSimulatorUserTier(
  highestPackage: string | undefined | null
): UserType {
  if (meetsMinTier(highestPackage, "svip")) return "svip";
  if (meetsMinTier(highestPackage, "vip")) return "vip";
  return "free";
}
